// French dictionary — professionally phrased translations for the interface and
// key homepage content. Missing keys fall back to English (see i18n/index.js).
const fr = {
  meta: {
    langName: "Français",
    home_title: "Chirurgie Esthétique Vietnam | Accompagnement international indépendant des patients",
    home_description:
      "Accompagnement international indépendant pour la chirurgie esthétique au Vietnam. Comprenez vos options, comparez les choix adaptés et demandez une étude de dossier privée et sans engagement avant de voyager.",
  },
  announcement: {
    text: "Accompagnement international indépendant des patients — ni clinique ni hôpital.",
    link: "Comment fonctionne notre étude de dossier",
  },
  nav: {
    procedures: "Interventions",
    choosing: "Choisir un chirurgien",
    safety: "Sécurité",
    costs: "Tarifs",
    revision: "Chirurgie de reprise",
    results: "Résultats",
    journey: "Parcours patient",
    guides: "Guides",
    about: "À propos",
    contact: "Contact",
    editorial: "Politique éditoriale",
  },
  cta: {
    caseReview: "Demander une étude de dossier",
    compare: "Comparer vos options",
    explore: "Découvrir les interventions",
    talk: "Parler à notre équipe",
    guidance: "Obtenir des conseils",
    sendPhotos: "Envoyer des photos pour examen",
    exploreOptions: "Découvrir les options",
    submitReview: "Envoyer pour examen privé",
    revisionReview: "Demander une étude pour reprise",
    whatsapp: "WhatsApp",
    menu: "Menu",
    close: "Fermer",
  },
  hero: {
    line1: "Vous envisagez",
    line2: "la chirurgie esthétique",
    line3: "au Vietnam ?",
    subheading:
      "Bénéficiez d’un accompagnement indépendant, comparez les options adaptées et comprenez votre parcours de soins avant de voyager.",
    paragraph:
      "Plastic Surgery Vietnam aide les patients internationaux à organiser des études de dossier initiales, des consultations directes, la planification du traitement et un soutien pratique avant, pendant et après le traitement au Vietnam.",
    trust: [
      "Privé et confidentiel",
      "Sans engagement",
      "Soutien aux patients internationaux",
    ],
    scroll: "Faites défiler",
  },
  marquee: [
    "Comprenez vos options",
    "Accompagnement indépendant",
    "Professionnels de santé agréés",
    "Attentes réalistes",
    "Privé et confidentiel",
    "Soutien international",
  ],
  form: {
    heading: "Demander une étude de dossier privée",
    intro:
      "Dites-nous ce que vous envisagez. Notre équipe examinera votre demande et vous expliquera les étapes appropriées.",
    fullName: "Nom complet",
    country: "Pays",
    email: "E-mail",
    phone: "Téléphone ou numéro WhatsApp",
    preferredContact: "Mode de contact préféré",
    procedureCategory: "Catégorie d’intervention",
    procedureType: "S’agit-il d’une première intervention ou d’une reprise ?",
    preferredMonth: "Mois de voyage souhaité",
    message: "Court message",
    photoUpload: "Envoi de photos sécurisé (facultatif)",
    photoHint: "JPG, PNG ou WEBP — jusqu’à 12 Mo chacune. Les photos sont stockées en toute sécurité.",
    consent:
      "J’accepte que Plastic Surgery Vietnam me contacte au sujet de ma demande et j’ai lu la politique de confidentialité et l’avertissement médical.",
    contactOptions: { email: "E-mail", phone: "Téléphone", whatsapp: "WhatsApp" },
    categoryOptions: {
      unsure: "Je ne suis pas sûr(e)",
      face: "Visage",
      nose: "Nez",
      breast: "Poitrine",
      body: "Corps",
      revision: "Chirurgie de reprise",
      other: "Autre",
    },
    typeOptions: {
      firstTime: "Première intervention",
      previousNoProblem: "Intervention antérieure sans problème actuel",
      revision: "Reprise ou correction",
      complication: "Complication ou préoccupation urgente",
    },
    placeholders: {
      select: "Veuillez sélectionner",
      message: "Décrivez brièvement ce que vous envisagez...",
      month: "ex. mars 2026",
    },
    success: {
      heading: "Merci — votre demande a bien été reçue",
      points: [
        "Votre demande a été reçue par notre équipe de soutien aux patients.",
        "Les photographies ne remplacent pas un examen en personne.",
        "Une recommandation de traitement finale provient d’un professionnel de santé agréé.",
        "Nous vous contacterons selon le mode de communication choisi.",
      ],
      again: "Envoyer une autre demande",
    },
    errors: {
      required: "Ce champ est obligatoire",
      email: "Veuillez saisir une adresse e-mail valide",
      consent: "Veuillez donner votre consentement pour continuer",
      submit: "Une erreur est survenue. Veuillez réessayer.",
    },
    disclaimer:
      "Les photographies ne servent qu’à un examen initial. Une recommandation finale provient toujours d’un professionnel de santé agréé après un examen en personne.",
  },
  footer: {
    description:
      "Une plateforme indépendante et internationale d’information et de coordination pour les personnes envisageant une chirurgie plastique, esthétique, reconstructrice ou de reprise au Vietnam.",
    procedures: "Interventions",
    guides: "Guides patients",
    contact: "Contact",
    languages: "Langue",
    legal: "Mentions légales",
    rights: "Tous droits réservés.",
  },
  common: {
    learnMore: "En savoir plus",
    readGuide: "Lire le guide",
    backHome: "Retour à l’accueil",
    breadcrumbHome: "Accueil",
    translationNotice:
      "Le contenu complet en français est en cours de préparation par notre équipe. L’interface et les informations clés sont disponibles dans votre langue ; certains articles détaillés sont affichés en anglais en attendant la finalisation des traductions professionnelles.",
  },
};

export default fr;
